import { SapOdpDatasetAdapter } from 'app/model/adapters/datasets/sap-odp-dataset.adapter';
import { AdapterRegistry, IModel, Metamodel } from 'shell-models-lib';
import { tabularPropertiesCommonAdapts } from 'app/model/adapters/datasets/tabular-type.dataset.adapter';
import { SapCdcDataset } from 'app/model/dataset/sap-cdc.dataset';

/**
 * @deprecated
 */
@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SapCdcDataset),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            ...tabularPropertiesCommonAdapts,
            typeProperties: {
                context: __IS_FABRIC_DPE__ ? undefined : '*',
                contextName: __IS_FABRIC_DPE__ ? '*' : undefined,
                objectName: '*'
            }
        }
    }
})
export class SapCdcDatasetAdapter extends SapOdpDatasetAdapter {
    protected model(): IModel {
        return SapCdcDataset.MODEL;
    }

    protected override getSchemaAlias(): string {
        return __IS_FABRIC_DPE__ ? 'contextName' : super.getSchemaAlias();
    }

}
